import { useEffect, useState } from "react";
import axios from "axios";
import { useSocialSignupAndLogin } from "./useSocialSignupAndLogin";
const useAuth = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [user, setUser] = useState(null);
  const { handleGoogle, socialLoading, socialError } = useSocialSignupAndLogin();
  useEffect(() => {
    const checkAuthStatus = () => {
      setLoading(true);
      const token = localStorage.getItem("CRM_token");
      const storedUser = localStorage.getItem("CRM_user");
      const googletoken = localStorage.getItem("googleToken");
      const refreshtoken = localStorage.getItem("googleRefreshToken");

      if (token && storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          setUser(parsedUser);
        } catch (err) {
          console.error("User data parsing error:", err);
          localStorage.removeItem("CRM_token");
          localStorage.removeItem("CRM_user");
          setUser(null);
        }
      }

      else if (googletoken && refreshtoken && storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          setUser(parsedUser);
        }
        catch (err) {
          console.error("User data parsing error:", err);
          localStorage.removeItem("googleToken");
          localStorage.removeItem("googleRefreshToken");
          localStorage.removeItem("CRM_user");
          setUser(null)
        }
      }
      else {
        setUser(null);
      }

      setLoading(false);
    };

    checkAuthStatus();
  }, []);


  const signIn = async (email, password) => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.post("/auth", {
        email,
        password,
        returnSecureToken: true,
      });

      if (response.data && response.data.idToken) {
        const userData = {
          token: response.data.idToken,
          email: response.data.email,
          displayName: response.data.displayName,
          profilePicture: response.data.profilePicture,
          localId: response.data.localId,

        };

        localStorage.setItem("CRM_token", response.data.idToken);
        localStorage.setItem("CRM_user", JSON.stringify(userData));

        setUser(userData);
        setLoading(false);
        return userData;
      } else {
        throw new Error("No token received");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Authentication failed");
      setLoading(false);
      throw err;
    }
  };
  const loginWithGoogle = async (subscriptionType) => {
    try {
      const response = await handleGoogle({ subscriptionType });
      if (response.user) {
        const userData = {
          token: response.user.accessToken,
          email: response.user.email,
          displayName: response.user.displayName,
          profilePicture: response.user.photoURL,
          localId: response.user.reloadUserInfo.localId,
          refreshToken: response.user.stsTokenManager.refreshToken, 
          uid: response.user.uid, 
        };
        
        localStorage.setItem("googleToken", response.user.accessToken);
        localStorage.setItem("googleRefreshToken", response.user.refreshToken);
        localStorage.setItem("CRM_user", JSON.stringify(userData));
        setUser(userData);
        setLoading(false);
        return userData;

      }
      else {
        throw new Error(" There is some problem with the provided info please,try again");
      }
    }
    catch (err) {
      setError("Authentication with Google failed");
      setUser(null);
      setLoading(false);
    }
  }

  const logout = (navigate) => {
    localStorage.removeItem("CRM_token");
    localStorage.removeItem("CRM_user");
    localStorage.removeItem("blog");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("token");

    setUser(null);
    console.log("logged out");

    if (navigate) {
      navigate("/login");
    }
  };
  return {
    user,
    signIn,
    loading,
    error,
    setError,
    setUser,
    logout,
    isAuthenticated: !!user,
    loginWithGoogle,
  };
};

export default useAuth;